const foundationMeta = [
  "Fundación Gastronomía Social",
  "RUT: 65.194.635-2",
  "Av. Recoleta 1179, Recoleta, Santiago de Chile",
  "privacidad@gastronomia.social",
]

export const LEGAL_DOCUMENTS = {
  "terminos-host": {
    slug: "terminos-host",
    title: "Términos y Condiciones de Participación y Tratamiento de Datos Personales",
    subtitle: "Almacenia",
    lead:
      "Estos términos regulan el acceso, registro, participación y uso de las plataformas, programas e iniciativas desarrolladas por la Fundación Gastronomía Social.",
    meta: foundationMeta,
    sections: [
      {
        title: "1. Objeto y alcance",
        paragraphs: [
          "Los presentes Términos y Condiciones regulan el acceso, registro, participación y uso de las plataformas digitales, programas, iniciativas, campañas y actividades desarrolladas por la Fundación, a nivel nacional e internacional.",
        ],
      },
      {
        title: "2. Aceptación",
        paragraphs: [
          "La participación en cualquiera de las iniciativas de la Fundación implica la aceptación expresa, libre, informada e inequívoca de estos Términos, así como de la Política de Privacidad asociada.",
        ],
      },
      {
        title: "3. Elegibilidad",
        paragraphs: [
          "Podrán participar personas naturales con capacidad legal conforme a la normativa de su jurisdicción.",
          "En el caso de menores de edad, se requerirá consentimiento previo de sus representantes legales.",
        ],
      },
      {
        title: "4. Registro y veracidad de la información",
        paragraphs: [
          "El usuario declara que la información proporcionada es veraz, completa y actualizada, siendo responsable de cualquier error o falsedad.",
        ],
      },
      {
        title: "5. Tratamiento de datos personales",
        paragraphs: [
          "La Fundación podrá recopilar y tratar datos personales conforme a la normativa aplicable en cada jurisdicción.",
        ],
        bullets: [
          "Ley N° 19.628 (Chile)",
          "Reglamento General de Protección de Datos (GDPR - Unión Europea)",
          "Normativas locales aplicables",
        ],
      },
      {
        title: "6. Finalidades del tratamiento",
        paragraphs: ["Los datos personales serán tratados para:"],
        bullets: [
          "Gestión de programas, promociones y actividades",
          "Identificación y contacto de participantes",
          "Evaluación de impacto social",
          "Elaboración de informes institucionales",
          "Cumplimiento de obligaciones legales",
          "Envío de comunicaciones, cuando exista base legal suficiente",
        ],
      },
      {
        title: "7. Consentimiento",
        paragraphs: [
          "Cuando corresponda, el tratamiento se basará en el consentimiento del titular.",
          "El titular podrá revocarlo en cualquier momento escribiendo a privacidad@gastronomia.social.",
        ],
        bullets: ["Libre", "Específico", "Informado", "Inequívoco"],
      },
      {
        title: "8. Transferencias internacionales de datos",
        paragraphs: [
          "El usuario autoriza el tratamiento de sus datos en otros países, garantizando la Fundación estándares adecuados de protección y seguridad.",
        ],
      },
      {
        title: "9. Limitación de responsabilidad",
        paragraphs: ["La Fundación no será responsable por:"],
        bullets: [
          "Fallas tecnológicas externas",
          "Uso indebido por parte del usuario",
          "Información incorrecta proporcionada",
        ],
      },
      {
        title: "10. Propiedad intelectual",
        paragraphs: [
          "Todos los contenidos, metodologías, plataformas y materiales asociados a la Fundación son de su propiedad o cuentan con licencias correspondientes.",
        ],
      },
      {
        title: "11. Modificaciones",
        paragraphs: [
          "La Fundación podrá modificar estos Términos en cualquier momento, informando a través de sus canales oficiales.",
        ],
      },
      {
        title: "12. Legislación aplicable",
        paragraphs: [
          "Se aplicará la normativa correspondiente según la jurisdicción del usuario, sin perjuicio de la legislación chilena como marco base.",
        ],
      },
    ],
  },
  privacidad: {
    slug: "privacidad",
    title: "Política de Privacidad",
    subtitle: "Versión internacional",
    lead:
      "La Fundación Gastronomía Social se compromete a proteger los datos personales conforme a estándares internacionales, garantizando transparencia, seguridad y respeto por los derechos de los titulares.",
    meta: foundationMeta,
    sections: [
      {
        title: "1. Compromiso global",
        paragraphs: [
          "Fundación Gastronomía Social protege los datos personales conforme a estándares internacionales y a las normas aplicables en cada jurisdicción.",
        ],
      },
      {
        title: "2. Responsable del tratamiento",
        paragraphs: [
          "Fundación Gastronomía Social es responsable del tratamiento de los datos personales tratados bajo esta política.",
        ],
      },
      {
        title: "3. Principios aplicables",
        bullets: [
          "Licitud, lealtad y transparencia",
          "Limitación de la finalidad",
          "Minimización de datos",
          "Exactitud",
          "Seguridad y confidencialidad",
          "Responsabilidad proactiva",
        ],
      },
      {
        title: "4. Categorías de datos",
        bullets: [
          "Datos identificativos",
          "Datos de contacto",
          "Datos socioeconómicos en programas sociales",
          "Datos de uso y comportamiento",
          "Datos técnicos",
        ],
      },
      {
        title: "5. Bases legales",
        bullets: [
          "Consentimiento",
          "Ejecución de programas",
          "Obligación legal",
          "Interés legítimo",
        ],
      },
      {
        title: "6. Finalidades",
        bullets: [
          "Operación de servicios",
          "Comunicación con usuarios",
          "Evaluación de impacto social",
          "Reportes institucionales",
          "Marketing, cuando corresponda",
        ],
      },
      {
        title: "7. Compartición de datos",
        paragraphs: [
          "Los datos podrán compartirse con proveedores tecnológicos, instituciones aliadas y entidades públicas o privadas, siempre bajo acuerdos de confidencialidad.",
        ],
      },
      {
        title: "8. Transferencias internacionales",
        paragraphs: [
          "Se garantizará el cumplimiento de estándares internacionales mediante cláusulas contractuales y medidas de seguridad adecuadas.",
        ],
      },
      {
        title: "9. Derechos del titular",
        paragraphs: [
          "El usuario podrá ejercer sus derechos escribiendo a privacidad@gastronomia.social.",
        ],
        bullets: [
          "Acceso",
          "Rectificación",
          "Eliminación",
          "Oposición",
          "Portabilidad",
          "Limitación del tratamiento",
        ],
      },
      {
        title: "10. Seguridad de la información",
        paragraphs: [
          "La Fundación implementa medidas técnicas y organizativas para proteger los datos frente a accesos no autorizados, pérdida o uso indebido.",
        ],
      },
      {
        title: "11. Conservación",
        paragraphs: [
          "Los datos serán conservados únicamente por el tiempo necesario para cumplir las finalidades descritas o exigencias legales.",
        ],
      },
      {
        title: "12. Datos sensibles",
        paragraphs: [
          "En programas sociales podrán tratarse datos sensibles, bajo consentimiento explícito y medidas reforzadas de protección.",
        ],
      },
      {
        title: "13. Menores de edad",
        paragraphs: [
          "El tratamiento de datos de menores requerirá autorización de sus representantes legales.",
        ],
      },
      {
        title: "14. Actualizaciones",
        paragraphs: [
          "La Fundación podrá modificar esta política en cualquier momento, publicando su versión actualizada.",
        ],
      },
      {
        title: "15. Contacto",
        paragraphs: [
          "Consultas o solicitudes: privacidad@gastronomia.social.",
          "Dirección: Av. Recoleta 1179, Recoleta, Santiago de Chile.",
        ],
      },
    ],
  },
  "terminos-restaurantes": {
    slug: "terminos-restaurantes",
    title: "Términos y Condiciones de Uso del Servicio para Restaurantes",
    subtitle: "Almacenia",
    lead:
      "Estos términos regulan la contratación, acceso y uso de los servicios tecnológicos, formativos y comerciales proporcionados por la Fundación Gastronomía Social a restaurantes y otros clientes comerciales.",
    meta: foundationMeta,
    sections: [
      {
        title: "1. Objeto",
        paragraphs: [
          "Los presentes Términos y Condiciones regulan la contratación, acceso y uso de los servicios tecnológicos, formativos y comerciales proporcionados por la Fundación, incluyendo la plataforma Almacenia.",
        ],
      },
      {
        title: "2. Naturaleza del servicio",
        paragraphs: ["El Servicio podrá incluir, entre otros:"],
        bullets: [
          "Plataforma digital de gestión de clientes y experiencias",
          "Sistemas de fidelización, promociones y campañas",
          "Herramientas de recopilación y análisis de datos",
          "Capacitación en hospitalidad y servicio",
          "Integración con marcas aliadas o campañas comerciales",
        ],
      },
      {
        title: "3. Aceptación",
        paragraphs: [
          "El uso del Servicio implica la aceptación plena de estos Términos por parte del Cliente, quien declara contar con facultades suficientes para contratar en representación del establecimiento.",
        ],
      },
      {
        title: "4. Registro y cuenta",
        paragraphs: ["El Cliente deberá:"],
        bullets: [
          "Proporcionar información veraz y actualizada",
          "Mantener la confidencialidad de sus credenciales",
          "Asumir responsabilidad por el uso de su cuenta",
        ],
      },
      {
        title: "5. Obligaciones del Cliente",
        paragraphs: ["El Cliente se obliga a:"],
        bullets: [
          "Utilizar el Servicio conforme a la ley y buenas prácticas comerciales",
          "No utilizar la plataforma para fines ilícitos o engañosos",
          "Obtener los consentimientos necesarios de sus clientes finales, cuando aplique",
          "Cumplir con la normativa de protección de datos aplicable",
        ],
      },
      {
        title: "6. Protección de datos y rol de las partes",
        paragraphs: [
          "La Fundación actuará como responsable del tratamiento respecto de sus propios datos y como encargado del tratamiento cuando procese datos en nombre del Cliente.",
          "El Cliente será responsable de los datos de sus propios usuarios o clientes.",
        ],
      },
      {
        title: "6.2 Obligaciones del Cliente en materia de datos",
        paragraphs: ["El Cliente declara y garantiza que:"],
        bullets: [
          "Cuenta con base legal para recopilar datos personales",
          "Ha informado adecuadamente a sus usuarios",
          "Cumple con las leyes aplicables, incluyendo GDPR y Ley 19.628 cuando corresponda",
        ],
      },
      {
        title: "6.3 Tratamiento por parte de la Fundación",
        paragraphs: ["La Fundación tratará los datos:"],
        bullets: [
          "Solo para prestar el Servicio",
          "Conforme a estándares de seguridad adecuados",
          "Bajo confidencialidad",
        ],
      },
      {
        title: "7. Uso de datos y analítica",
        paragraphs: [
          "La Fundación podrá utilizar datos anonimizados y agregados para análisis de comportamiento, mejora del servicio y estudios de impacto, sin identificar a personas individuales.",
        ],
      },
      {
        title: "8. Integraciones con terceros",
        paragraphs: ["El Servicio podrá integrarse con:"],
        bullets: [
          "Marcas comerciales",
          "Plataformas tecnológicas",
          "Programas de fidelización",
        ],
      },
      {
        title: "9. Propiedad intelectual",
        paragraphs: [
          "Todos los derechos sobre el software, la plataforma Almacenia, las metodologías y los contenidos pertenecen a la Fundación o sus licenciantes.",
          "El Cliente recibe solo un derecho de uso limitado, no exclusivo y revocable.",
        ],
      },
      {
        title: "10. Condiciones económicas",
        paragraphs: ["El uso del Servicio podrá estar sujeto a:"],
        bullets: [
          "Comisiones por uso",
          "Servicios adicionales",
        ],
      },
      {
        title: "11. Responsabilidad",
        paragraphs: ["La Fundación no garantiza:"],
        bullets: [
          "Resultados comerciales específicos",
          "Incrementos en ventas",
          "Fidelización automática",
        ],
      },
      {
        title: "12. Limitación de responsabilidad",
        paragraphs: ["En la máxima medida permitida por la ley, la Fundación no será responsable por:"],
        bullets: [
          "Daños indirectos",
          "Pérdidas de ingresos",
          "Interrupciones del servicio",
        ],
      },
      {
        title: "13. Terminación",
        paragraphs: [
          "La Fundación podrá suspender o terminar el acceso al Servicio en caso de incumplimiento de estos Términos, uso indebido o requerimientos legales.",
          "El Cliente podrá cancelar el servicio conforme a las condiciones acordadas.",
        ],
      },
      {
        title: "14. Confidencialidad",
        paragraphs: [
          "Ambas partes se obligan a mantener confidencial toda la información sensible intercambiada.",
        ],
      },
      {
        title: "15. Modificaciones",
        paragraphs: [
          "La Fundación podrá modificar estos Términos, notificando al Cliente por medios razonables.",
        ],
      },
      {
        title: "16. Legislación y jurisdicción",
        paragraphs: [
          "Estos Términos se regirán por la legislación aplicable según la jurisdicción del Cliente, con referencia base en la legislación chilena.",
        ],
      },
      {
        title: "Anexo: Política de Tratamiento de Datos para Clientes (B2B)",
        paragraphs: [
          "Esta política regula el tratamiento de datos personales en el contexto de la prestación de servicios a restaurantes y clientes comerciales.",
        ],
      },
      {
        title: "Anexo 1. Alcance",
        paragraphs: [
          "Aplica al tratamiento de datos personales de clientes finales del restaurante, personal del restaurante y datos de uso de la plataforma.",
        ],
      },
      {
        title: "Anexo 2. Tipos de datos",
        bullets: [
          "Datos de clientes finales del restaurante",
          "Datos del personal del restaurante",
          "Datos de uso de la plataforma",
        ],
      },
      {
        title: "Anexo 3. Finalidad",
        bullets: [
          "Operación del servicio",
          "Soporte técnico",
          "Analítica y mejora",
          "Reportes de desempeño",
        ],
      },
      {
        title: "Anexo 4. Seguridad",
        bullets: [
          "Controles de acceso",
          "Protocolos de seguridad",
          "Buenas prácticas internacionales",
        ],
      },
      {
        title: "Anexo 5. Transferencias internacionales",
        paragraphs: [
          "Se podrán realizar transferencias conforme a estándares adecuados de protección.",
        ],
      },
      {
        title: "Anexo 6. Derechos",
        paragraphs: [
          "Los titulares podrán ejercer sus derechos a través de privacidad@gastronomia.social.",
        ],
      },
    ],
  },
}

export const getLegalDocumentBySlug = (slug = "") => LEGAL_DOCUMENTS[slug] || null
